module.exports = __webpack_public_path__ + "static/img/team.fff1591.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fr/team.jpg
// module id = a8sP
// module chunks = 1